import { Component, OnInit } from '@angular/core';

import { AuditService } from '../../core/services/audit/audit.service';
import { AuditEvent } from '../../core/models/audit/audit-event.model';
import { AuditEventDisplayComponent } from '../../shared/components/audit-event-display/audit-event-display.component';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { AlertComponent } from '../../shared/components/alert/alert.component';
import { OverviewHubComponent } from '../../shared/components/overview-hub/overview-hub.component';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { RevenueOverviewComponent } from '../revenue-overview/revenue-overview.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [AuditEventDisplayComponent, LoadingComponent, AlertComponent, OverviewHubComponent, ButtonComponent, RevenueOverviewComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  userEventsLoading = false;
  error?: string;
  events: AuditEvent[] = [];

  constructor(private auditService: AuditService) {}

  ngOnInit(): void {
    this.fetchEvents();
  }

  fetchEvents(): void {
    this.userEventsLoading = true;
    this.error = undefined;

    this.auditService.getLastEvents().subscribe({
      next: (data) => {
        this.events = (data || [])
          .slice(0, 3)
          .sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime());
        this.userEventsLoading = false;
      },
      error: (err) => {
        this.error = 'Não foi possível carregar os últimos eventos.';
        this.userEventsLoading = false;
        console.error(err);
      }
    });
  }

  protected readonly localStorage = localStorage;
}
